(() => {
  const ORIGIN = 'https://www.sweettouch.co.kr';
  const BRIDGE = `${ORIGIN}/vote-bridge.html`;
  const KEYS = ['black', 'sage', 'amber', 'white', 'blossom', 'lilac'];
  const initSignup = root => {
    root.querySelectorAll('[data-st-updates]').forEach(box => {
      const tags = box.querySelector('[data-st-subscription-tags]');
      if (!tags) return;
      const voter = box.hasAttribute('data-st-voter') || new URLSearchParams(location.search).get('src') === 'voter';
      tags.value = `newsletter,consent-v20261010${voter ? ',voter' : ''}`;
    });
  };
  function start(section) {
    if (section.dataset.stReady) return;
    section.dataset.stReady = '1';
    const decoder = document.createElement('textarea');
    const messages = Object.fromEntries(Object.entries(JSON.parse(section.querySelector('[data-st-messages]').textContent)).map(([key, value]) => {
      decoder.innerHTML = value;
      return [key, decoder.value];
    }));
    const form = section.querySelector('[data-st-vote-form]');
    const button = section.querySelector('[data-st-submit]');
    const status = section.querySelector('[data-st-status]');
    const after = section.querySelector('[data-st-after-vote]');
    const fallback = section.querySelector('[data-st-fallback]');
    const resultsNote = section.querySelector('[data-st-results-note]');
    const bars = section.querySelector('[data-st-results-bars]');
    let ready = false;
    let pending = null;
    let attemptedAt = 0;
    let bridgeTimeout;
    const frame = document.createElement('iframe');
    frame.hidden = true;
    frame.title = 'Sweet Touch vote connection';
    frame.referrerPolicy = 'strict-origin';
    section.append(frame);
    // randomUUID is missing in older Safari; keep the same UUID v4 shape.
    const id = () => {
      if (crypto.randomUUID) return crypto.randomUUID();
      const b = crypto.getRandomValues(new Uint8Array(16));
      b[6] = (b[6] & 15) | 64;
      b[8] = (b[8] & 63) | 128;
      const h = Array.from(b, x => x.toString(16).padStart(2, '0')).join('');
      return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
    };
    const channel = id();
    function send(type, payload = {}) {
      const requestId = id();
      frame.contentWindow.postMessage({type, requestId, channel, ...payload}, ORIGIN);
      return requestId;
    }
    function drawResults(data) {
      bars.hidden = true;
      if (!data || !Number.isSafeInteger(data.total) || data.total < 0 || !Number.isSafeInteger(data.minToShow) || data.minToShow < 30 || !/^\d{4}-\d{2}-\d{2}$/.test(data.asOf || '') || !data.counts || !KEYS.every(key => Number.isSafeInteger(data.counts[key]) && data.counts[key] >= 0) || KEYS.reduce((sum, key) => sum + data.counts[key], 0) !== data.total) {
        resultsNote.textContent = messages.results_unavailable;
        return;
      }
      if (data.total < data.minToShow || data.total === 0) {
        resultsNote.textContent = `${messages.results_wait} ${messages.results_as_of.replace('{date}', data.asOf)}`;
        return;
      }
      resultsNote.textContent = messages.results_as_of.replace('{date}', data.asOf);
      KEYS.forEach(key => {
        const row = bars.querySelector(`[data-result-key="${key}"]`);
        const percent = data.counts[key] / data.total * 100;
        row.querySelector('meter').value = percent;
        row.querySelector('[data-st-percent]').textContent = `${Math.round(percent)}%`;
      });
      bars.hidden = false;
    }
    function receive(event) {
      if (event.origin !== ORIGIN || event.source !== frame.contentWindow || !event.data || event.data.channel !== channel) return;
      const data = event.data;
      if (data.type === 'st-vote:ready') {
        clearTimeout(bridgeTimeout);
        ready = true;
        button.disabled = false;
        status.textContent = messages.ready;
        fallback.hidden = true;
        drawResults(data.results);
      }
      if (data.type !== 'st-vote:result' || !pending || data.requestId !== pending.id) return;
      clearTimeout(pending.timer);
      pending = null;
      form.removeAttribute('aria-busy');
      if (data.ok === true) {
        status.textContent = messages.success;
        form.hidden = true;
        after.hidden = false;
        after.focus({preventScroll: true});
      } else {
        status.textContent = data.reason === 'cooldown' ? messages.cooldown : data.reason === 'uncertain' ? messages.uncertain : messages.failed;
        fallback.hidden = false;
        setTimeout(() => { if (!pending) button.disabled = !ready; }, Math.max(0, 60000 - (Date.now() - attemptedAt)));
      }
    }
    window.addEventListener('message', receive);
    frame.addEventListener('load', () => send('st-vote:init'));
    frame.src = BRIDGE;
    bridgeTimeout = setTimeout(() => {
      if (ready) return;
      button.disabled = true;
      status.textContent = messages.unavailable;
      resultsNote.textContent = messages.results_unavailable;
      fallback.hidden = false;
    }, 10000);
    form.addEventListener('change', event => {
      if (event.target.name !== 'colour') return;
      section.querySelectorAll('[data-st-colour-image]').forEach(image => { image.hidden = image.dataset.stColourImage !== event.target.dataset.colourKey; });
    });
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity() || pending || !ready) return;
      const values = new FormData(form);
      if (values.get('bot-field')) return;
      if (Date.now() - attemptedAt < 60000) { status.textContent = messages.cooldown; return; }
      attemptedAt = Date.now();
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      status.textContent = messages.sending;
      const requestId = send('st-vote:submit', {colour: values.get('colour'), country: values.get('country') || 'Not given', 'bot-field': values.get('bot-field') || ''});
      pending = {id: requestId, timer: setTimeout(() => {
        pending = null;
        form.removeAttribute('aria-busy');
        status.textContent = messages.uncertain;
        fallback.hidden = false;
        setTimeout(() => { button.disabled = !ready; }, Math.max(0, 60000 - (Date.now() - attemptedAt)));
      }, 20000)};
    });
    // Another customer form on the page (e.g. footer newsletter) can also render a
    // posted/error state here; only reopen "Your vote is in" after this signup was used.
    const FLAG = 'st-voter-signup';
    let store = null;
    try { store = window.sessionStorage; } catch (e) { store = null; }
    let voterPosted = false;
    try { if (store) { voterPosted = store.getItem(FLAG) === '1'; store.removeItem(FLAG); } } catch (e) { voterPosted = false; }
    const signup = after.querySelector('form');
    if (signup) signup.addEventListener('submit', () => { try { if (store) store.setItem(FLAG, '1'); } catch (e) {} });
    if (voterPosted && after.querySelector('.st-updates-form__success, [role="alert"]')) {
      form.hidden = true;
      after.hidden = false;
      after.querySelector('details').open = true;
    }
    const onUnload = event => {
      if (event.target.contains(section)) {
        window.removeEventListener('message', receive);
        clearTimeout(bridgeTimeout);
        if (pending) clearTimeout(pending.timer);
        document.removeEventListener('shopify:section:unload', onUnload);
      }
    };
    document.addEventListener('shopify:section:unload', onUnload);
  }
  function init(root) {
    initSignup(root);
    root.querySelectorAll('[data-st-vote]').forEach(start);
  }
  init(document);
  if (!window.stColourVoteEditorListener) {
    window.stColourVoteEditorListener = true;
    document.addEventListener('shopify:section:load', event => init(event.target));
  }
})();
